import { useAppContext } from "../../context";
import { getFixedText } from "../../utils";

interface IResultView {
    data: any;
}

export const ResultView = ({ data }: IResultView) => {

    const { isMobile } = useAppContext();

    return (
        <div className="text-center">
            <h2 className={`font-villula ${isMobile ? 'mb-4 text-2xl leading-6' : 'mb-6 text-[40px]/[40px]'}`}>
                {getFixedText(data.title)}
            </h2>
            <p className={isMobile ? "text-[17px] leading-5" : "text-[24px]/[31px]"}>{getFixedText(data.text)}</p>
        </div>
    )
};